import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `
    display: flex;
    flex-direction: Column;
    width: 100%;
    margin-bottom: 2rem;
    h3 {
        font-size: 2.2rem;
        color: rgb(20, 24, 35);
        font-family: ${props.theme.font.fontFamily};
        font-weight: bold;
        padding-bottom: 1.5rem;
    }
`,
);
export const ContentWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
  border-radius: 0.6rem;
  padding: 3rem 2rem;
  display: flex;
  width: 100%;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
      padding-bottom: 2rem;
    }
  }
`;
export const Question = styled.div(
  props => `
        font-family: ${props.theme.font.fontFamily};
        font-size: 1.8rem;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom:1.5rem;
        p { width: 90%}
    `,
);
export const Answer = styled.div`
    font-size: 1.6rem
    line-height: 1.2;
    display:flex;
    flex-direction: row;

`;
export const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.2rem;
    height: 2.2rem;
    background-color: #eef4fd;
    border-radius: 50%;
    color: black;
    font-size: 1.4rem;
    margin-right:1rem;
}
`;

export const Description = styled.div`
  width: 90%;
`;
